import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom'
import { fetchServers, syncServer} from '../store/actions/servers';
import { cancelTimePickerDialog, closeTimePickerDialog, openTimePickerDialog} from '../store/actions/timepick';
import ServerList from '../components/serverList';
import { authRedirect } from '../lib/utils';
import { withLoadingComponent, withErrorComponent } from '../components/loading';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.servers,
        onCreateServerClick: () => {
            ownProps.history.push(`/servers/new`)
        },
        openServer: (index) => {
            let server = state.servers.servers[index];
            ownProps.history.push(`/servers/${server.id}`)
        },
        timepickDialog: {...state.timepick}
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchServers: () => dispatch(fetchServers()).catch(authRedirect(ownProps)),
        syncServer: (id, params) => dispatch(syncServer(id, params)),
        openTimePickerDialog: (id) => dispatch(openTimePickerDialog(id)),
        closeTimePickerDialog: () => dispatch(closeTimePickerDialog()),
        cancelTimePickerDialog: () => dispatch(cancelTimePickerDialog())
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchServers();
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent
)(ServerList);


// WEBPACK FOOTER //
// ./src/containers/ServersContainer.js